<template>
<Modal :label="`${inputType} Data Aspek`">
    <InputCustom
      v-model="item.name" 
      :error="error.name"
      :errorMsg="errorMsg.name"
      @onFocus="resetError('name')"
      label="Aspek Penilaian"
    >
    </InputCustom>

    <InputCustom
      v-model="item.weight" 
      :error="error.weight"
      :errorMsg="errorMsg.weight"
      @onFocus="resetError('weight')"
      placeholder="Contoh: 50"
      label="Bobot"
      @keypress="numberOnlyInput"
    >
    </InputCustom>

    <div class="y-inputField">
        <div class="y-labelText">
          Tipe
        </div>
        <div class="y-inputPlace y-hasIcon-right">
            <div class="y-select-hasIcon" style="width: 100%">
                <select class="y-select" v-model="item.type">
                    <option class="y-option"
                      value="normal"
                      >Normal</option>
                    <option class="y-option"
                      value="uploader"
                      >Uploader</option>
                </select>
                <div class="y-select-icon" >
                    <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                </div>
            </div>
        </div>
    </div>

    <template #actionButton>
      <ButtonCustom
        :disabled="loading" type="secondary" size="sm" class="r-mlr-10"
        @click.prevent="resetData()"
      > Batal </ButtonCustom>
      
      <ButtonCustom
        :loading="loading"
        type="primary" size="sm" class="r-mlr-10"
        @click.prevent="sendData()"
      >{{inputType}} </ButtonCustom>
    </template>
</Modal>
</template>
<script>
import common from '@/mixins/function/common'
import { mapGetters, mapActions } from 'vuex'
import validation from '@/mixins/function/validation'
import Modal from '@/components/Helper/Modal'
import inputNumber from '@/mixins/function/inputNumber'

export default {
  mixins: [common, validation, inputNumber],
  components: {
    Modal,
  },
  props: {
    inputType: {
      require: true
    },
    categoryId: {
      require: true
    }
  },
  computed: {
    ...mapGetters({
      item: 'tapiRubricField/getItem',
    })
  },
  data: () => ({
    loading: false,
    error: {
      name: false,
      weight: false,
      type: false
    },
    errorMsg: {
      name: 'Tidak boleh kosong',
      weight: 'Tidak boleh kosong',
      type: 'Tidak boleh kosong'
    },
  }),
  methods: {
    ...mapActions({
      store: 'tapiRubricField/store',
      update: 'tapiRubricField/update',
    }),
    resetData(){
      this.$emit('resetData')
    },
    async validation(){
      const field = [
        'name',
        'weight',
        'type'
      ]
      return await this.validate(field,this.item)
    },
    async sendData(){
      const errorcount = await this.validation()
      if(errorcount === 0){

        this.loading = true
        const payload = {
          ...this.item,
          tapi_rubric_category_id: this.categoryId
        }
        if(this.inputType === 'Tambahkan') await this.store(payload)
        else await this.update(payload)
        this.loading = false

        const response = this.getResponse('tapiRubricField')
        this.showSnackbar({
          type: response.status == 1 ? "success" : "error",
          text: response.msg
        })

        if(response.status === 1){
          this.resetData()
          this.$emit('getData')
        }
      }else{
        this.showSnackbar({
          type: "error",
          text: "Mohon periksa kembali"
        })
      }
    },
  }
}
</script>